import { render, staticRenderFns } from "./PreTest.vue?vue&type=template&id=9b51d4b2&"
import script from "./PreTest.vue?vue&type=script&lang=ts&"
export * from "./PreTest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports